import React, { useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import DemoLeadForm from "../components/demo/DemoLeadForm";
import DemoAdminTabs from "../components/demo/DemoAdminTabs";
import DemoProgress from "../components/demo/DemoProgress";
import DemoEtvFrame from "../components/demo/DemoEtvFrame";
import DemoEtvControls from "../components/demo/DemoEtvControls";
import DemoFlutterFrame from "../components/demo/DemoFlutterFrame";
import useDemoSession from "../features/demo/useDemoSession";
import "../styles/Demo.css";

const formatRemaining = (seconds = 0) => {
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(remainder).padStart(2, "0")}`;
};

const DemoBrandNavigation = () => (
  <div className="demo-brand-navigation">
    <a href="/my" aria-label="Etikaf untuk Masjid">
      <img className="demo-brand-logo" src="/assets/etikaf-arab.svg" alt="Etikaf" />
    </a>
    <a className="demo-back-link" href="/my" aria-label="Kembali ke Etikaf untuk Masjid">
      <FiArrowLeft aria-hidden="true" /> Untuk Masjid
    </a>
  </div>
);

const Demo = ({ demoFlow }) => {
  const liveFlow = useDemoSession();
  const flow = demoFlow || liveFlow;
  const [activePreview, setActivePreview] = useState("etv");
  const [previewPending, setPreviewPending] = useState(false);

  if (["lead", "creating"].includes(flow.phase)) {
    return (
      <main className="demo-entry">
        <DemoBrandNavigation />
        <DemoLeadForm onSubmit={flow.create} disabled={flow.phase === "creating"} />
        <p className="demo-privacy-note">Maklumat hubungan digunakan untuk susulan Etikaf sahaja dan tidak dipaparkan dalam demo.</p>
      </main>
    );
  }

  if (flow.phase === "loading") {
    return <main className="demo-state"><DemoBrandNavigation /><h1>Menyediakan demo anda…</h1></main>;
  }

  if (flow.phase === "expired") {
    return (
      <main className="demo-state">
        <DemoBrandNavigation />
        <h1>Sesi demo telah tamat</h1>
        <p>Demo berlangsung selama 30 minit untuk melindungi data sesi anda.</p>
        <button type="button" onClick={flow.startOver}>Mulakan sesi baharu</button>
      </main>
    );
  }

  if (flow.phase === "error") {
    return <main className="demo-state" role="alert"><DemoBrandNavigation /><h1>Demo belum dapat dibuka</h1><p>{flow.error}</p></main>;
  }

  const session = flow.session || {};
  return (
    <main className="demo-page">
      <header className="demo-topbar">
        <DemoBrandNavigation />
        <div className="demo-session-identity">
          <strong>{session.organisationName}</strong>
          <span>{session.location}</span>
        </div>
        <div className="demo-session-time"><small>Sesi berbaki</small><strong>{formatRemaining(flow.remainingSeconds)}</strong></div>
      </header>

      <DemoProgress step={session.activeStep} delivery={session.delivery} />

      <div className="demo-workspace">
        <section className="demo-admin-panel" aria-label="Panel admin demo">
          <DemoAdminTabs
            announcement={{
              onSubmit: flow.send,
              onReset: flow.reset,
              disabled: flow.sending,
            }}
            kuliah={{
              current: session.kuliah,
              onSubmit: flow.publishKuliah,
              onClear: flow.clearKuliah,
              disabled: flow.sending,
            }}
          />
          {flow.error && <p role="alert">{flow.error}</p>}
        </section>

        <div className="demo-preview-tabs" role="tablist" aria-label="Pilih paparan demo">
          <button type="button" role="tab" aria-selected={activePreview === "etv"} onClick={() => setActivePreview("etv")}>ETV</button>
          <button type="button" role="tab" aria-selected={activePreview === "app"} onClick={() => setActivePreview("app")}>Aplikasi</button>
        </div>

        <div className={`demo-etv-column ${activePreview === "etv" ? "is-mobile-active" : ""}`}>
          <DemoEtvFrame session={session} sessionId={flow.sessionId} markRendered={flow.markRendered} />
          <DemoEtvControls
            preview={session.etvPreview}
            disabled={previewPending}
            onChange={async (mode) => {
              if (!flow.setEtvPreview || previewPending) return;
              setPreviewPending(true);
              try { await flow.setEtvPreview(mode, "Maghrib"); }
              finally { setPreviewPending(false); }
            }}
          />
        </div>
        <div className={`demo-app-column ${activePreview === "app" ? "is-mobile-active" : ""}`}>
          <DemoFlutterFrame session={session} sessionId={flow.sessionId} markRendered={flow.markRendered} />
        </div>
      </div>
    </main>
  );
};

export default Demo;
